import { ContextColor } from "../constants/color.enum";
import { getContextColorStyle } from "../utils/colors.utils";

export function useContextColorStyle(contextColorName?: ContextColor, colorName?: string | null, namespace: string = 'app'): React.CSSProperties {
  return getContextColorStyle(contextColorName, colorName, namespace)
}